import React from "react";

import ForestBar from "../../svgs/ForestBar";
import PrimaryBar from "../../svgs/PrimaryBar";
import { useSignUpForm } from "./SignUpFormContext";

const FormProgress = () => {
  const { steps, currentStep } = useSignUpForm();

  const progressList =
    steps &&
    steps.map((_, idx) =>
      currentStep >= idx ? (
        <PrimaryBar key={idx} className="w-16 sm:w-full" />
      ) : (
        <ForestBar key={idx} className="w-16 sm:w-full" />
      )
    );

  return (
    <div className="flex w-full md:max-w-[431px] md:mx-auto justify-center items-start gap-2">
      {progressList}
    </div>
  );
};

export default FormProgress;
